import _defaultTo from 'lodash/defaultTo';
import _forIn from 'lodash/forIn';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isObjectLike from 'lodash/isObjectLike';
import _orderBy from 'lodash/orderBy';
import _some from 'lodash/some';
import _toFinite from 'lodash/toFinite';
import _values from 'lodash/values';
// Serialization
import { deserialize, serialize } from 'serializr';
import { deviceBatchSchema, deviceBatchUserSchema } from './schemas';
// Color
import { statusPalette } from '../components/core/colors';
// Custom
import { findInList } from '../utils/Tools';

/**
* Serialization
*/
const serializerKey = 'device_production_batch';

const deserializeDeviceBatch = (data) => deserialize(deviceBatchSchema, data);

const serializeDeviceBatch = ({
  name, date, volume, deviceModelId, distributions,
}) => ({
  [serializerKey]: {
    ...serialize(deviceBatchSchema, {
      name: _defaultTo(name, null),
      date: _defaultTo(date, null),
      volume: _defaultTo(volume, null),
      device_model_id: _defaultTo(deviceModelId, null),
      distributions: _defaultTo(distributions, null),
    }),
  },
});

const deserializeDeviceBatchUser = (data) => deserialize(deviceBatchUserSchema, data);

/**
* Lists
*/
const deviceBatchStatusList = [
  {
    key: 'pending',
    value: 'pending',
    labelId: 'deviceBatch.status.pending',
    icon: 'pending',
    color: statusPalette.pending,
  },
  {
    key: 'committed',
    value: 'committed',
    labelId: 'deviceBatch.status.committed',
    icon: 'success',
    color: statusPalette.success,
  },
];

/**
* Utils
*/
const sortDeviceBatches = (deviceBatches, fields = ['date'], dirs = ['desc']) => (_orderBy(deviceBatches, fields, dirs));

const deviceBatchTitle = (deviceBatchData) => _get(deviceBatchData, 'name', '');

const deviceBatchStatus = (deviceBatch) => findInList(deviceBatchStatusList, 'value', deviceBatch, 'status');

const deviceBatchLoadingDistributions = (deviceBatch) => {
  if (!deviceBatch) {
    return false;
  }
  const { distributions } = deviceBatch;
  if (!distributions || _isEmpty(distributions)) {
    return false;
  }
  return _some(_values(distributions), ['loading', true]);
};

const deviceBatchHasDistribution = (deviceBatch, distributionId) => {
  let hasDistribution = false;
  _forIn(deviceBatch.distributions, (distObjOrId) => {
    const distId = _isObjectLike(distObjOrId) ? distObjOrId.id : distObjOrId;
    if (_toFinite(distId) === _toFinite(distributionId)) {
      hasDistribution = true;
      return false;
    }
  });
  return hasDistribution;
};

/**
* Model
*/
const deviceBatch = {
  // Name and icon
  name: 'deviceBatch',
  icon: 'deviceBatch',

  // Serialization
  deserialize: deserializeDeviceBatch,
  serialize: serializeDeviceBatch,
  deserializeUser: deserializeDeviceBatchUser,

  // Lists
  statusList: deviceBatchStatusList,

  // Sort elements
  sortElements: sortDeviceBatches,

  // Utils
  title: deviceBatchTitle,
  status: deviceBatchStatus,
  loadingDistributions: deviceBatchLoadingDistributions,
  hasDistribution: deviceBatchHasDistribution,

  // List features
  listFeatures: {
    // Default list param (not used)
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [],
    },

    // Columns
    columnsQuantity: () => ({
      xs: 2,
      sm: 2,
      md: 5,
      lg: 5,
      xl: 5,
    }),
    columns: [
      {
        key: 'date',
        labelId: 'field.date',
        field: 'date',
        sortable: false,
      },
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        sortable: false,
      },
      {
        key: 'deviceModel',
        labelId: 'field.deviceModel',
        field: 'deviceModel',
        sortable: false,
        className: 'hidden-sm-down',
      },
      {
        key: 'status',
        labelId: 'field.status',
        field: 'status',
        sortable: false,
        className: 'table-content-1 table-content-center hidden-sm-down',
      },
      {
        key: 'commitDate',
        labelId: 'field.commitDate',
        field: 'commitDate',
        sortable: false,
        className: 'hidden-sm-down',
      },
    ],

    // Search fields
    searchFields: [],
  },

  // Devices columns
  devicesColumns: [
    {
      key: 'serial',
      labelId: 'field.serial',
      field: 'serial',
      sortable: false,
    },
  ],
};

module.exports = deviceBatch;



// WEBPACK FOOTER //
// ./models/deviceBatch.js